import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { SOCIAL_LINKS } from '../data/social'
import { track } from '../lib/analytics'
import { SocksLandingPromo } from './SocksLandingPromo'

export const WHATSAPP_CHANNEL_URL = 'https://whatsapp.com/channel/0029VbAkrA3ATRSoNX0sUh0e'

/** A compact channel section followed by the current wholesale promotion. */
export function WhatsAppChannelSection({ showSocksPromo = true }: { showSocksPromo?: boolean }) {
  return (
    <>
      <section
        aria-labelledby="whatsapp-channel-section-title"
        data-secondary-section="whatsapp-channel"
        className="px-4 py-8"
      >
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-3xl border border-emerald-200/80 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
          <FontAwesomeIcon
            icon={faWhatsapp}
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-10 -right-8 rotate-12 text-[12rem] text-emerald-600/15"
          />
          <div className="relative flex flex-col gap-5 px-5 py-6 sm:px-8">
            <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3 border-b border-dashed border-emerald-300/70 pb-5">
              <p className="text-sm leading-snug text-slate-700">
                <span className="font-black text-slate-900">Ikuti media sosial Dropify</span> untuk informasi
                produk dan panduan pemesanan grosir.
              </p>
              <div className="flex items-center gap-2.5">
                {SOCIAL_LINKS.map(({ label, href, icon }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Ikuti Dropify di ${label}`}
                    onClick={() =>
                      track('click_social', {
                        social_network: label,
                        link_url: href,
                        cta_placement: 'whatsapp_channel_section',
                      })
                    }
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-emerald-200 bg-white text-green-800 shadow-sm transition-all hover:-translate-y-0.5 hover:border-green-700 hover:bg-green-800 hover:text-white hover:shadow-md motion-reduce:transition-none motion-reduce:hover:translate-y-0"
                  >
                    <FontAwesomeIcon icon={icon} className="h-4 w-4" />
                  </a>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
              <div className="flex items-start gap-4 max-[360px]:flex-col">
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-green-700 text-white shadow-lg shadow-green-700/25">
                  <FontAwesomeIcon icon={faWhatsapp} className="h-6 w-6" />
                </span>
                <div className="min-w-0">
                  <h2 id="whatsapp-channel-section-title" className="text-lg font-black text-slate-900">
                    Informasi stok dan promo Dropify
                  </h2>
                  <p className="mt-0.5 max-w-xl text-sm leading-relaxed text-slate-600">
                    Ikuti channel WhatsApp Dropify untuk menerima informasi restock, produk baru,
                    dan promo.
                  </p>
                </div>
              </div>
              <a
                href={WHATSAPP_CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  track('join_group', {
                    method: 'whatsapp_channel',
                    cta_placement: 'body_section',
                    page_path: typeof window !== 'undefined' ? window.location.pathname : undefined,
                  })
                }
                className="inline-flex min-h-11 flex-shrink-0 items-center justify-center gap-2 rounded-xl bg-green-700 px-6 py-3 text-sm font-bold text-white shadow-lg shadow-green-700/25 transition-all hover:-translate-y-0.5 hover:bg-green-800 hover:shadow-xl hover:shadow-green-700/30 motion-reduce:transition-none motion-reduce:hover:translate-y-0"
                aria-label="Ikuti channel WhatsApp Dropify"
              >
                <FontAwesomeIcon icon={faWhatsapp} className="h-4 w-4" />
                Ikuti channel WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
      {showSocksPromo && <SocksLandingPromo />}
    </>
  )
}
